import { findPhoneNumbersInText } from 'libphonenumber-js';
import * as React from 'react';

import { ChatHiddenPhone, ChatPhone } from '../../../components/ChatPhone';

export const replacePhoneNumbers = ({
  text,
  isOutcoming,
  isPhonesHidden,
  onClick,
}: {
  text: string;
  isOutcoming?: boolean;
  isPhonesHidden: boolean;
  onClick: () => void;
}) => {
  let lastIndex = 0;
  const result: (string | React.JSX.Element)[] = [];

  const phoneNumbers = findPhoneNumbersInText(text, 'RU');
  const withHidden = isPhonesHidden && !isOutcoming;

  if (!phoneNumbers.length) {
    return text;
  }

  phoneNumbers.forEach(({ number, startsAt, endsAt }, index) => {
    const originalPhone = text.slice(startsAt, endsAt);
    const minifiedPhone = originalPhone.replace(/(\d{2}\s*-*\d{2})$/, 'XXXX');

    const link = withHidden ? (
      <ChatHiddenPhone key={index} phone={minifiedPhone} onClick={onClick} />
    ) : (
      <ChatPhone key={index} phone={originalPhone} href={number.number} isOutcoming={isOutcoming} />
    );

    result.push(text.slice(lastIndex, startsAt));
    result.push(link);
    lastIndex = endsAt;
  });

  result.push(text.slice(lastIndex));

  return result;
};
